<template>
  <div class="modal-container">
    <transition name="modal">
      <confirm-modal
        v-if="$store.getters['confirm/active']"
        v-bind="$store.getters['confirm/options']"
      />
    </transition>
    <transition-group
      name="modal"
      tag="div"
    >
      <component
        :is="modal.component"
        v-for="(modal, index) in modals"
        :key="index + 0"
        v-bind="modal.attributes"
      />
    </transition-group>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  computed: {
    modals () {
      return cloneDeep(this.$store.getters['modal/modals'])
    },
  },
  created () {
    this.$root.__modalContainer = this
  },
}
</script>
